import React, { Component } from 'react'

export default class Login extends Component {
  componentDidMount = () => {
    localStorage.clear()
    window.location.replace('/')
  }
  render() {
    return (
      <div className="loadingwall">
        <div id="loader">
          <div id="shadow"></div>
          <div id="box"></div>
        </div>
      </div>
    )
  }
}
